import { IntlShape, injectIntl } from "react-intl";

import { ERRORS_LANG_DEFS, keyTypes } from "shared/types";

interface Props {
  error?: keyTypes;
  intl: IntlShape;
  errorMessageOptions?: Record<string, string | number>;
}

const FormErrorText = ({ error, intl, errorMessageOptions = {} }: Props) => {
  return intl.formatMessage(
    { id: ERRORS_LANG_DEFS[error] },
    errorMessageOptions
  );
};

export default injectIntl(FormErrorText);
